import flatpickr from 'flatpickr';
import { Italian } from 'flatpickr/dist/l10n/it';
import NavigationUtils from './utils/NavigationUtils';

flatpickr.localize(Italian);

export function copyOnClipboard(selector, message = 'Contenuto copiato') {
	const copyText = selector instanceof Element ? selector : document.getElementById(selector);
	const content = copyText?.getAttribute('data-copy');
	if (!content || content === '') return;

	const copyToClipboard = (text) => {
		if (navigator.clipboard?.writeText) {
			return navigator.clipboard.writeText(text);
		}
		// Fallback per contesti dove clipboard API non è disponibile (es. iframe senza permessi)
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		try {
			document.execCommand('copy');
		} finally {
			document.body.removeChild(textarea);
		}
	};

	try {
		copyToClipboard(content);
		if (window.toastr && message) {
			window.toastr.success(message);
		}
	} catch (_err) {
		if (window.toastr) {
			window.toastr.warning('Copia non disponibile in questo contesto');
		}
	}
}

export function emptyClipboard() {
	try {
		if (navigator.clipboard?.writeText) {
			navigator.clipboard.writeText('');
		}
	} catch (_err) {
		// ignore
	}
}

export function getLastVersion() {
	const lastVersion = localStorage.getItem('naxos-version');
	if (!lastVersion) {
		setLastVersion();
	}
	return localStorage.getItem('naxos-version');
}

export function setLastVersion(version = null) {
	localStorage.setItem('naxos-version', version ?? window.version);
}

export function checkForUpdates() {
	if (getLastVersion() !== window.version) {
		$('#last-updates-button').show();
	} else {
		$('#last-updates-button').hide();
	}
}

export function openLastUpdatesWindow(url) {
	const lastVersion = getLastVersion();
	NavigationUtils.createAndOpenPanel(url + '?current_version=' + window.version + (lastVersion ? '&version=' + lastVersion : ''));
}
